import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export const SlashCircleIcon: FC<IconProps> = ({ iconColor = '#344054', className, ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="12"
    viewBox="0 0 12 12"
    width="12"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.84254 7.72208C1.6164 7.17611 1.5 6.59095 1.5 6C1.5 5.40905 1.6164 4.82389 1.84254 4.27792C2.06869 3.73196 2.40016 3.23588 2.81802 2.81802C3.23588 2.40016 3.73196 2.06869 4.27792 1.84254C4.82389 1.6164 5.40905 1.5 6 1.5C6.59095 1.5 7.17611 1.6164 7.72208 1.84254C8.26804 2.06869 8.76412 2.40016 9.18198 2.81802C9.59984 3.23588 9.93131 3.73196 10.1575 4.27792C10.3836 4.82389 10.5 5.40905 10.5 6C10.5 6.59095 10.3836 7.17611 10.1575 7.72208C9.93131 8.26804 9.59984 8.76412 9.18198 9.18198C8.76412 9.59984 8.26804 9.93131 7.72208 10.1575C7.17611 10.3836 6.59095 10.5 6 10.5C5.40905 10.5 4.82389 10.3836 4.27792 10.1575C3.73196 9.93131 3.23588 9.59984 2.81802 9.18198C2.40016 8.76412 2.06869 8.26804 1.84254 7.72208Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.84985 2.84961L9.14985 9.14961"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
